module.exports = "<div class=\"modal-content\">\n    <div class=\"modal-header text-center\">\n        <h4 class=\"modal-title\">{{ header }}</h4>\n    </div>\n    <div class=\"modal-body\">\n        <i class=\"fa fa-spinner fa-pulse\"></i>  {{ message }}        \n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /app/src/app/theme/components/modals/components/modalMessage/modalMessage.html
// module id = ../../../../../src/app/theme/components/modals/components/modalMessage/modalMessage.html
// module chunks = 14